import { Box } from "@mui/material";

function NavItemIcon({ color = "currentColor", icon: Icon, size = 13, sx }) {
    if (!Icon) {
        return null;
    }

    return (
        <Box
            component={Icon}
            aria-hidden="true"
            focusable="false"
            fontSize="inherit"
            size={size}
            sx={{
                width: size,
                height: size,
                flex: `0 0 ${size}px`,
                display: "block",
                color,
                fontSize: size,
                ...sx,
            }}
        />
    );
}

export { NavItemIcon };
